export default class Price {
  constructor(id = null, object = '', quantity = 0, unitPrice = 0) {
    this.id = id;
    this.object = object;
    this.quantity = quantity;
    this.unitPrice = unitPrice;
  }
}
